let rizevo_login_data = localStorage.getItem("rizevo_login_data");
if (rizevo_login_data) rizevo_login_data = JSON.parse(rizevo_login_data);
else rizevo_login_data = null;

const isLive = () => {
  if (window.location.hostname === "www.rizevo.com" || window.location.hostname === "app.kindlybook.com") {
    return true;
  }
  return false;
};

const servers = [
  process.env.REACT_APP_APP_DEV_DOMAIN,
  process.env.REACT_APP_APP_LIVE_DOMAIN,
  "http://127.0.0.1:8000/api",
];
let api = servers[0];
if (isLive()) {
  api = servers[1];
}
if(window.location.hostname==='localhost')
{
  api = servers[0];
}
const register = `${api}/register`;
const login = `${api}/login`;

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
const postOptions = {
  method: "POST",
  headers,
};

const getOptions = {
  method: "GET",
  headers,
};

export {
  register,
  login,
  postOptions,
  getOptions,
  api,
  headers,
  rizevo_login_data,
};
